import { ConsentDeliveryState } from '@/enums'
import { HATEOASLink } from '@/types/hateoasLink.interface'

export class PatientConsentDocument {
  constructor(init: Partial<PatientConsentDocument> = {}) {
    this.id = init.id || 0
    this.patientId = init.patientId || 0
    this.htmlUrl = init.htmlUrl || ''
    this.pdfUrl = init.pdfUrl || ''
    this.deliveryState = init.deliveryState || ConsentDeliveryState.Failed
    this.deliveryStateBool = this.deliveryState == ConsentDeliveryState.ManuallyChecked
    this.consentDate = init.consentDate
    this._links = {
      setDeliveredManually: init._links?.setDeliveredManually,
      setPatientConsentDate: init._links?.setPatientConsentDate,
    }
  }

  id: number
  patientId: number
  htmlUrl: string
  pdfUrl: string
  deliveryState: ConsentDeliveryState
  deliveryStateBool: boolean
  consentDate?: Date
  _links: {
    setDeliveredManually?: HATEOASLink
    setPatientConsentDate?: HATEOASLink
  }
}
